export default __webpack_public_path__ + "images/c5d004d2c1e3bb2626b49f03597c4ef4-rephrasing_my_thoughts.svg";